import React from 'react';
import { useStore } from '../../store';
import { getSymbolContext } from '../../selectors/symbolContext';

export function TrapPanel({ symbol }: { symbol: string }) {
  const { symbolData, settings, weights } = useStore();
  const data = symbolData[symbol];
  if (!data?.candles?.length) return (
    <div className="card">
      <div className="sl">Trap Detection</div>
      <div className="empty"><div className="icon">🪤</div><h3>No Data</h3><p>Import OHLCV data to detect trap patterns.</p></div>
    </div>
  );

  const ctx = getSymbolContext(symbol, data, settings, weights);
  const traps = ctx?.traps ?? [];
  const sevColor: Record<string, string> = { High: 'var(--red)', Medium: 'var(--amber)', Low: 'var(--blue)', None: 'var(--t3)' };
  const sevBadge: Record<string, string> = { High: 'b-red', Medium: 'b-amber', Low: 'b-blue', None: 'b-dim' };

  return (
    <div className="card">
      <div className="sl">Trap Detection</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 12 }}>
        {traps.map((t, i) => (
          <div key={i} className="card-inner" style={{ borderLeft: `2px solid ${sevColor[t.severity]}` }}>
            <div className="fsb mb4">
              <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--t0)' }}>{t.type}</div>
              <span className={`badge ${sevBadge[t.severity]}`}>{t.severity}</span>
            </div>
            {t.level !== null && <div className="mono" style={{ fontSize: 12, color: 'var(--amber)', marginBottom: 3 }}>Level: {t.level.toFixed(2)}{t.label ? ` (${t.label})` : ''}</div>}
            <div style={{ fontSize: 13, color: 'var(--t1)', lineHeight: 1.6 }}>{t.reason}</div>
          </div>
        ))}
      </div>
      <div className="div" />
      <div className="sl">Pattern Reference</div>
      <div className="g2" style={{ gap: 5 }}>
        {[
          ['Bull Trap', 'Break above level → close back below. Short opportunity.'],
          ['Bear Trap', 'Break below level → reclaim above. Long opportunity.'],
          ['Sweep & Reclaim', 'Wick through zone, body closes back inside range.'],
          ['Weak Breakout', 'Break without volume — increased failure probability.'],
          ['Failed Continuation', 'Momentum stalls after confirmed structural break.'],
          ['Equal Level Raid', 'Multiple equal highs/lows cleared in single sweep.'],
        ].map(([t, d]) => (
          <div key={t} className="card-inner">
            <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--t1)', marginBottom: 2 }}>{t}</div>
            <div style={{ fontSize: 11, color: 'var(--t2)', lineHeight: 1.5 }}>{d}</div>
          </div>
        ))}
      </div>
      <div className="disclaimer mt8">Trap signals are probabilistic — confirmation required before acting on any pattern.</div>
    </div>
  );
}
